(function () {
  const els = document.querySelectorAll('.history .load--fade.loading');
  if (!('IntersectionObserver' in window)) {
    els.forEach(el => el.classList.remove('loading'));
    return;
  }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.remove('loading');
        e.target.classList.add('loaded');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  els.forEach(el => io.observe(el));
})();
